/* ==========================================================================
   Son Gezilenler — localStorage tabanlı ürün geçmişi.
   Ürün sayfasında mevcut ürünü kaydeder; bölümde kalanları /products/{handle}.js
   ile çekip basit kart olarak render eder. Framework yok.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'recently-viewed';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function money(cents) {
    if (window.Theme && typeof window.Theme.money === 'function') return window.Theme.money(cents);
    return ((cents || 0) / 100).toFixed(2);
  }

  function card(p) {
    var img = '';
    if (p.featured_image) {
      var src = p.featured_image;
      if (src.indexOf('//') === 0) src = 'https:' + src;
      img = '<img src="' + src + '" alt="" loading="lazy" width="300" height="300" class="rv-card__img">';
    }
    var vendor = p.vendor ? '<span class="rv-card__vendor">' + p.vendor + '</span>' : '';
    return (
      '<a class="rv-card" href="' + p.url + '">' +
      '<span class="rv-card__media">' + img + '</span>' +
      '<span class="rv-card__body">' + vendor +
      '<span class="rv-card__title">' + p.title + '</span>' +
      '<span class="rv-card__price">' + money(p.price) + '</span>' +
      '</span></a>'
    );
  }

  function fetchProduct(handle) {
    return fetch((window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') : '') + '/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function init() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;

    var current = section.getAttribute('data-current-handle');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var list = read();

    // Mevcut ürünü geçmişe ekle (en başa, tekrarsız)
    if (current) {
      list = list.filter(function (h) { return h !== current; });
      list.unshift(current);
      write(list);
    }

    // Gösterilecekler: mevcut ürün hariç
    var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var html = products.filter(Boolean).map(card).join('');
      if (!html) return;
      grid.innerHTML = html;
      section.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
